import styles from "./PaymentButtons.module.scss";
import PaymentPartsIcon from "./PaymentPartsIcon";

interface PartsButtonProps {
  icon: { systemId: number; count: number, content: string };
  onClick: () => void;
  title: string;
}

const PartsButton = ({ onClick, title, icon }: PartsButtonProps) => {
  return (
    <button type="button" className={styles.partsButton} onClick={onClick}>
      {title}
      <div className={styles.icon}>
        <PaymentPartsIcon icon={icon} />
      </div>
    </button>
  );
};

export default PartsButton;
